import { lazy } from "react";
import Loadable from "components/Loadable";

const CountryList = Loadable(
  lazy(() => import("features/country/components/List"))
);
const CountryPage = Loadable(
  lazy(() => import("features/country/components/Page"))
);

const routes = {
  path: "country",
  children: [
    { path: "", element: <CountryList /> },
    { path: "add", element: <CountryPage /> },
    { path: "edit/:countryID?", element: <CountryPage /> },
  ],
};

export default routes;
